import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export class TeiasoftBreadCrumb{
  newIndex?:number;
  obj?: string;
}


@Component({
  selector: 'teiasoft-breadcrumb',
  templateUrl: './teiasoft-breadcrumb.component.html',
  styleUrls: ['./teiasoft-breadcrumb.component.scss']
})
export class TeiasoftBreadcrumbComponent implements OnInit, OnChanges {
  @Input() dataSet: any[] = new Array();
  @Input() columnToShow: string = '';
  @Input() disabled: boolean = false;
  @Input() activeIndex: number = -1;

  @Output() tbcClick: EventEmitter<TeiasoftBreadCrumb> = new EventEmitter();

  constructor(private translate: TranslateService){}

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["dataSet"]){
      this.dataSet = new Array();
      this.dataSet = changes["dataSet"].currentValue;
    }

    if (changes && changes["columnToShow"]){
      this.columnToShow = changes["columnToShow"].currentValue;
    }

    if (changes && changes["disabled"]){
      this.disabled = changes["disabled"].currentValue;
    }

    if (changes && changes["activeIndex"]){
      this.activeIndex = changes["activeIndex"].currentValue;
    }
  }

  /* METHODS */
  getvalue(row:any):string{
    let _ret:any = row[this.columnToShow]
    if (_ret == undefined || _ret == '') _ret = this.translate.instant('commons.new');
    return _ret;
  }

  onTbcClick(row: any, i:number){
    if (row.disabled) return;
    let _item: TeiasoftBreadCrumb = new TeiasoftBreadCrumb();
    _item.newIndex = i;
    _item.obj = JSON.stringify(row);
    this.tbcClick.emit(_item);
  }

  getMarginLeft(i: number): string{
    if (i == 0)
      return "0.5";
    else
      return "2";
   }

}
